var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { maxStudyAdditionalSections } from "healthex-common/constants";
import { ProjectPageName, ProjectSectionName } from "healthex-common/project.data.dtos";
import { StudyTranslationLanguage } from "healthex-common/study.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../../../Infra/RemoteData";
import { SimpleDialogModel } from "../../SimpleDialogModel";
export class AddJoinCommonInformedConsentBaseViewModel {
    constructor(opts) {
        this.learnMoreDialog = new SimpleDialogModel();
        this.addSectionDialog = new SimpleDialogModel();
        this.disposers = [];
        this.addSectionTitle = null;
        this.addAdditionalSection = async (imageId) => {
            var _a, _b, _c, _d, _e;
            const confirmed = await this.addSectionDialog.showAndWait();
            if (!confirmed) {
                this.closeAddSectionDialog(false);
                return;
            }
            try {
                this.formModel.updateInput({
                    additionalSections: [
                        ...((_a = this.formModel.input.additionalSections) !== null && _a !== void 0 ? _a : []),
                        {
                            id: `temp_${crypto.randomUUID()}`,
                            title: (_b = this.addSectionTitle) !== null && _b !== void 0 ? _b : "",
                            description: "",
                            included: true,
                            language: StudyTranslationLanguage.en,
                        },
                    ],
                });
                await this.refreshStudy();
                await new Promise((resolve) => setTimeout(resolve, 1000));
                let additionalSection = (_c = this.studyAdditionalSections) === null || _c === void 0 ? void 0 : _c.find((section) => section.title === this.addSectionTitle);
                if (!additionalSection) {
                    additionalSection = (_d = this.studyAdditionalSections) === null || _d === void 0 ? void 0 : _d[((_e = this.studyAdditionalSections) === null || _e === void 0 ? void 0 : _e.length) - 1];
                }
                if (additionalSection && imageId) {
                    await this.handleMove(imageId, ProjectPageName.PATIENT_EXPERIENCE, ProjectSectionName.ADDITIONAL_INFORMATION, additionalSection.id);
                }
            }
            catch (error) {
                console.error("Error adding additional section:", error);
            }
            this.closeAddSectionDialog(true);
        };
        this.closeAddSectionDialog = (choice) => {
            this.addSectionDialog.open = false;
            this.addSectionTitle = null;
        };
        this.updateAddSectionTitle = (title) => {
            this.addSectionTitle = title;
        };
        this.addProjectUIManager = opts.addProjectUIManager;
    }
    run() { }
    stop() {
        this.disposers.forEach((disposer) => disposer());
        this.disposers = [];
    }
    get formModel() {
        return this.addProjectUIManager.informedConsentFormModel;
    }
    get aiGeneratedFieldsModel() {
        return this.addProjectUIManager.aiGeneratedFieldsModel;
    }
    get showMinorParticipantConsent() {
        if (this.study === NOT_LOADED || !this.study)
            return false;
        return this.formModel.input.minorParticipantConsentEnabled;
    }
    get study() {
        return this.addProjectUIManager.study;
    }
    get studyId() {
        if (this.study === NOT_LOADED || !this.study)
            return null;
        return this.addProjectUIManager.studyId;
    }
    get studyAddedByOrganization() {
        if (this.study === NOT_LOADED || !this.study)
            return null;
        return this.study.addedByOrganization;
    }
    get orgName() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.addedByOrganization.name;
    }
    get orgId() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.addedByOrganization.id;
    }
    get isInterventionalStudy() {
        return this.addProjectUIManager.isInterventionalStudy;
    }
    get icfTextSegments() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.icfTextSegments;
    }
    get studyAdditionalSections() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.additionalSections;
    }
    get studySectionImages() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.studySectionImages;
    }
    get getSectionImages() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a;
            if (this.study === NOT_LOADED || this.study === null)
                return null;
            const images = (_a = this.study.studySectionImages) === null || _a === void 0 ? void 0 : _a.find((section) => section.sectionName === sectionName);
            if (sectionName === ProjectSectionName.ADDITIONAL_INFORMATION && additionalSectionId) {
                let filteredImages = images === null || images === void 0 ? void 0 : images.images.filter((img) => img.additionalSectionId === additionalSectionId && img.language === language);
                if (language !== StudyTranslationLanguage.en && filteredImages) {
                    filteredImages = filteredImages.map((img) => {
                        var _a;
                        return {
                            ...img,
                            imageUrl: img.imageUrl ||
                                (img.translatedFrom ? (_a = images === null || images === void 0 ? void 0 : images.images.find((pic) => pic.id === img.translatedFrom)) === null || _a === void 0 ? void 0 : _a.imageUrl : null) ||
                                "",
                        };
                    });
                }
                return filteredImages;
            }
            let filteredImages = images === null || images === void 0 ? void 0 : images.images.filter((img) => !img.additionalSectionId && img.language === language);
            if (language !== StudyTranslationLanguage.en && filteredImages) {
                filteredImages = filteredImages.map((img) => {
                    var _a;
                    return {
                        ...img,
                        imageUrl: img.imageUrl ||
                            (img.translatedFrom ? (_a = images === null || images === void 0 ? void 0 : images.images.find((pic) => pic.id === img.translatedFrom)) === null || _a === void 0 ? void 0 : _a.imageUrl : null) ||
                            "",
                    };
                });
            }
            return filteredImages;
        };
    }
    get getSectionImagesCount() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a, _b;
            return (_b = (_a = this.getSectionImages(sectionName, language, additionalSectionId)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        };
    }
    get getAdditionalSectionImages() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a;
            if (this.study === NOT_LOADED || this.study === null)
                return null;
            return (_a = this.study.studySectionImages) === null || _a === void 0 ? void 0 : _a.find((section) => {
                return (section.sectionName === sectionName &&
                    section.images.find((image) => image.additionalSectionId === additionalSectionId && image.language === language));
            });
        };
    }
    get getComponentKey() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId, additionalSectionIndex) => {
            return additionalSectionIndex
                ? `${sectionName}-${additionalSectionIndex}-${this.getSectionImagesCount(sectionName, language, additionalSectionId)}`
                : `${sectionName}-${this.getSectionImagesCount(sectionName, language, additionalSectionId)}`;
        };
    }
    async refreshStudy() {
        await this.addProjectUIManager.refreshStudy();
    }
    get pdda() {
        if (this.study === NOT_LOADED || this.study === null)
            return false;
        return this.study.pdda;
    }
    get reviewedItems() {
        if (!this.icfTextSegments)
            return null;
        return this.icfTextSegments.filter((item) => item.reviewed);
    }
    get unReviewedItems() {
        if (!this.icfTextSegments)
            return null;
        return this.icfTextSegments.filter((item) => !item.reviewed);
    }
    get totalReviewedItemsCount() {
        var _a, _b;
        return (_b = (_a = this.reviewedItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    }
    get totalUnReviewedItemsCount() {
        var _a, _b;
        return (_b = (_a = this.unReviewedItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    }
    get topBannerInfo() {
        return null;
    }
    get needsIdentifiedData() {
        return this.addProjectUIManager.needsIdentifiedData;
    }
    get topBannerHeight() {
        return this.addProjectUIManager.topBannerHeight;
    }
    get currentPageLoading() {
        return this.addProjectUIManager.currentPageLoading;
    }
    updateStudy(patientFacingDetails) {
        void this.addProjectUIManager.updateStudyWithUploadedICFData(patientFacingDetails);
    }
    showLearnMoreDialog() {
        this.learnMoreDialog.open = true;
    }
    deleteTimeline(index) {
        if (!this.formModel.input.timelineVisits)
            return;
        if (this.formModel.input.timelineVisits.length === 1) {
            this.formModel.input.timelineVisits[0] = { period: "", description: "" };
        }
        else {
            this.formModel.input.timelineVisits.splice(index, 1);
        }
        this.formModel.updateInput({
            timelineVisits: this.formModel.input.timelineVisits,
        });
    }
    updateTopBannerHeight(height) {
        this.addProjectUIManager.updateTopBannerHeight(height);
    }
    get hasReachedMaxAdditionalSections() {
        var _a, _b;
        return ((_b = (_a = this.studyAdditionalSections) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) >= maxStudyAdditionalSections;
    }
    async handleMove(imageId, destinationPage, destinationSection, additionalSectionId) {
    }
    getSectionTitleLabel() {
        var _a, _b;
        return `Additional information section #${((_b = (_a = this.studyAdditionalSections) === null || _a === void 0 ? void 0 : _a.filter((section) => section.language === StudyTranslationLanguage.en).length) !== null && _b !== void 0 ? _b : 0) + 1}`;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AddJoinCommonInformedConsentBaseViewModel.prototype, "addSectionTitle", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "study", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "studyId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "studyAddedByOrganization", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "orgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "orgId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "isInterventionalStudy", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "icfTextSegments", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "studyAdditionalSections", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "studySectionImages", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "getSectionImages", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "getSectionImagesCount", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "getAdditionalSectionImages", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "getComponentKey", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "pdda", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "reviewedItems", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "unReviewedItems", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "totalReviewedItemsCount", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "totalUnReviewedItemsCount", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "topBannerInfo", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "needsIdentifiedData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "topBannerHeight", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "currentPageLoading", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], AddJoinCommonInformedConsentBaseViewModel.prototype, "hasReachedMaxAdditionalSections", null);
